export default "__VITE_ASSET__vnB2Zkyf__"